import styled from 'styled-components';

export const AppContainer = styled.main`
  margin-top: 24px;
  @media (min-width: 978px){
      margin-left: calc(50vw - 495px);
      max-width: 978px;
  }
`;
